      //获取购物车商品信息
      async function getCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Failed to load cart');
        return res.json();
      }

      //自定义添加购物车功能工具组件-----
      async function addCartMulted(productList,options = {}){
        const {
          timeout = 5000,      // 默认5秒超时
          retry = 2,           // 失败重试2次
          retryDelay = 1000    // 重试间隔1秒
        } = options;

        const results = [];
        for (const obj of productList) {
          let lastError = null;
          let success = false;
          
          // 重试循环
          for (let attempt = 0; attempt <= retry; attempt++) {
            try {
            
              // 使用 Promise.race 实现超时
              const response = await Promise.race([
                fetch(`/cart/add.js`,{
                  method:'POST',
                  headers:{
                    'Content-type':'application/json'
                  },
                  body: JSON.stringify({
                        id: obj.id,
                        quantity: obj.quantity
                    })
                }),

                new Promise((_, reject) => 
                  setTimeout(() => reject(new Error('请求超时')), timeout)
                )
              ]);
              
              if (!response.ok) {
                throw new Error(`HTTP错误: ${response.status}`);
              }
              
              const data = await response.json();
              results.push({ success: true, data, attempts: attempt + 1 });
              success = true;
              break; // 成功了就跳出重试循环
              
            } catch (error) {
              lastError = error;
              console.error(`✗ ${obj.id} 请求失败 (尝试 ${attempt + 1}):`, error.message);
              
              // 如果不是最后一次尝试，等待后重试
              if (attempt < retry) {
                await new Promise(resolve => setTimeout(resolve, retryDelay));
              }
            }
          }
    
          // 如果所有重试都失败了
          if (!success) {
            results.push({ 
              id, 
              success: false, 
              error: lastError.message,
              attempts: retry + 1 
            });
            console.error(`✗ ${obj.id} 最终失败`);
          }
        }
        
        return results;
      }
      // 多个加购（并发，加购先后顺序根据数组的顺序）
      async function customAddCartMulted(productList,loadingDOm){
        const startTime = Date.now();

        const results = await addCartMulted(productList,{
          timeout: 5000,     // 5秒超时
          retry: 2,           // 失败重试2次
          retryDelay: 500   // 重试间隔0.5秒
        });
        openAndReloadHaloCart('/cart?view=ajax_side_cart')
        loadingDOm.style.cssText += 'display:none'

        const endTime = Date.now()
        const httpTime = ((endTime-startTime)/1000).toFixed(2)+'秒'
        
        console.log('消耗时间：',httpTime)

      }

      // 添加到购物车(单个加购)
      async function customAddCart(variantId,quantity,loadingDOm) {
        try{
          const response = await fetch('/cart/add.js',{
            method:'POST',
            headers:{
              'Content-type':'application/json'
            },
            body: JSON.stringify({
                  id: variantId,
                  quantity: quantity
              })
          })
          if(response.ok){

            openAndReloadHaloCart('/cart?view=ajax_side_cart')
            loadingDOm.style.cssText += 'display:none'
          }else{
            loadingDOm.style.cssText += 'display:none'
          }

        }catch(error){
          console.error('添加到购物车失败:', error);
          loadingDOm.style.cssText += 'display:none'
        }
      }

      //弹出侧边栏购物车
      async function triggerCartDrawer() {

        // 兼容多种购物车打开
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

        if (window.CartDrawer?.open) return window.CartDrawer.open();
        if (window.Theme?.Cart?.open) return window.Theme.Cart.open();
        if (window.SlideCart?.open) return window.SlideCart.open();
        if (window.Minicart?.open) return window.Minicart.open();
        if (document.querySelector('cart-drawer')?.open) return document.querySelector('cart-drawer').open();

        const toggle =
          document.querySelector('[aria-controls="CartDrawer"]') ||
          document.querySelector('[data-drawer-toggle="CartDrawer"]') ||
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[data-action="open-drawer"][data-drawer-id*="Cart"]') ||
          document.querySelector('button[name="cart"], a[href="/cart"]');
        if (toggle) toggle.click();

        (window.HaloTheme?.Cart?.getCart?.()) ||
        (window.HaloTheme?.ajaxCart?.getCart?.()) ||
        document.dispatchEvent(new CustomEvent('halo:cart:refresh')) ||
        document.dispatchEvent(new CustomEvent('halo:mini-cart:refresh'));

        getCart().then(cart => {
          console.log('产品items', cart);
          window.HALO.updateSidebarCart(cart)
        });
      }

      //及时刷新购物车方法
      async function openAndReloadHaloCart(EP_URL) {
        // 1) 打开抽屉
        triggerCartDrawer();

        // 2) 拉取抽屉HTML并直接写入现有容器
        const html = await fetch(`${EP_URL}${EP_URL.includes('?') ? '&' : '?'}t=${Date.now()}`, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' }
        }).then(r => r.text());

        const tmp = document.createElement('div');
        tmp.innerHTML = html;

          // 逐块映射：左边是页面现有容器，右边是返回HTML中对应容器
        const mappings = [
          // 列表区域
          { page: '.previewCart',        resp: '.previewCart' },
          // 合计/小计
          { page: '.previewCartInfo',     resp: '.previewCartInfo' },
          // // 优惠/配送提示（如有）
          // { page: '#halo-cart-promos',       resp: '#halo-cart-promos' },
          // // 结算按钮区域
          // { page: '#halo-cart-footer',       resp: '#halo-cart-footer' },
          // // 购物车数量角标（如存在）
          { page: '#cart-icon-bubble',       resp: '#cart-icon-bubble' },
        ];

        for (const { page, resp } of mappings) {
          const pageEl = document.querySelector(page);
          const respEl = tmp.querySelector(resp);
          if (pageEl && respEl) {
            // 只替换内部，保留容器本身与事件绑定
            pageEl.innerHTML = respEl.innerHTML;
          }
        }

        // 通知主题脚本（常见监听）
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      }

      //原生加购方法
      const nativeAddCart = (option) => {
        const {
          btnName = 'Add To Cart'
        } = option
        const addCartDom = ' <form action="/cart/add" method="post" class="variants" enctype="multipart/form-data">\
                                  <input type="hidden" name="id" value='+option.id+'>\
                                  <input type="hidden" name="quantity" value="1">\
                                  <button type="submit" name="add" data-btn-addtocart="" data-available="" class="custom_buy_bnt product-form__submit button button--primary an-">\
                                      '+btnName+'\
                                  </button>\
                              </form>'
        return  addCartDom
      }

      //最新加购方法
async function addCartMultied(idArr,loadingDOm,maskObj) {
    try {
        if (!Array.isArray(idArr) || !idArr.length) {
            console.warn('addCartMultied: idArr is empty');
            return null;
        }

        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: idArr
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.description || 'Add to cart failed');
        }

        console.log('Add cart success:', data);

        // 使用主题原生方法：
        // 打开购物车 + 重新请求页面 + 刷新 .previewCart
        if (typeof window.openAndReloadHaloCart === 'function') {
            await window.openAndReloadHaloCart(window.location.pathname);
        } else {
            console.warn('openAndReloadHaloCart is not available');
        }

        // 额外同步购物车数量
        if (typeof window.getCart === 'function') {
            const cart = await window.getCart();
            updateHaloCartCount(cart);
        }
        if(loadingDOm) loadingDOm.style.cssText += 'display:none'
        if(maskObj) maskObj.style.cssText += 'display:none'

        return data;

    } catch (error) {
        console.error('addCartMultied error:', error);
        return null;
    }
}




function updateHaloCartCount(cart) {
    if (!cart) return;

    const count = cart.item_count;

    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = count;
    });

    document.querySelectorAll('.cartCount').forEach(function(el) {
        el.textContent = count;
    });
}